import { createSelector } from 'reselect'
import getGiftCardPayableAmount from './getGiftCardPayableAmount'
import { isUsingGiftCard } from '../view/generic'

const getGiftCardPayAmount = createSelector(
  (state: App.State) => isUsingGiftCard(state),
  (state: App.State) => getGiftCardPayableAmount(state),
  (isUsingGiftCard, amount) => isUsingGiftCard ? amount : 0,
)

export default getGiftCardPayAmount
